export const ElementTypesText = {
    'text': 'Text Input',
    'text-area': 'Text Area',
    'number': 'Number Input',
    'email': 'Email Input',
    'date': 'Date Input',
    dropdown: 'Dropdown',
    checkbox: 'CheckBox',
    radio: 'Radio',
}
